import { useContext, useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import authContext from "../../../../AuthContext/authContext";
import appActions from "../../../../ReduxStore/appDataSlice";
import "./PrintModal.css";
import Home from "../Home/Home";
import Table from "../../Table/Table";
import classes from "../../Table/Table.module.css";
import { toast } from "react-toastify";
import axios from "axios";
import ConfirmModal from "../ConfirmModal/ConfirmModal";
const base_url = process.env.REACT_APP_BASE_URL;
const moment = require("moment");
const SpecialVisitorWrapper = () => {
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [printUrl, setPrintUrl] = useState("");
  const [isPrintLoading, setIsPrintLoading] = useState(false);
  const printRequested = useRef(false);
  const activeCompany = useSelector((state) => state.appData.activeCompany);
  const activeLocation = useSelector((state) => state.appData.activeLocation);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ctx = useContext(authContext);
  const token = ctx.token;
  const userType = ctx.userData.user_type;
  const [visitorToDelete, setVisitorToDelete] = useState({});
  const sortDirection = useSelector((state) => state.appData.sortDirection);
  const dateSort = (rowA, rowB) => {
    dispatch(appActions.setSortDirection(sortDirection === "1" ? "-1" : "1"));
    localStorage.setItem("sortDirection", sortDirection === "1" ? "-1" : "1");
  };

  useEffect(() => {
    if (
      userType === "Company Manager" ||
      userType === "location" ||
      userType === "Building Manager" ||
      userType === "company"
    ) {
      let showCreatePass =
        !(userType === "admin" || userType === "subadmin") &&
        (activeCompany["delagateCheck"] || activeCompany["vendorCheck"]);
      if (!showCreatePass) {
        toast.error("Special Visitor is disabled");
        navigate("/dashboard");
      }
    }
  }, []);

  const isHidden = userType == "admin" || userType == "subadmin";

  const maskText = (text) => {
    text = String(text);
    if (text.length <= 2) {
      return "*".repeat(text.length);
    }
    const maskedText = text.slice(0, 3) + "*".repeat(text.length - 3);
    return maskedText;
  };

  const handleEdit = (id) => {
    dispatch(appActions.setActiveEditVisitorId(id));
    localStorage.setItem("activeEditVisitorId", id);
    navigate("/edit-special-visitor");
  };

  const handleDelete = (id) => {
    setIsPrintLoading(true);
    let reqObj = {
      method: "DELETE",
      url: `${base_url}/visitor/delete-special-visitor/${id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    axios(reqObj)
      .then((res) => {
        setIsPrintLoading(false);
        toast.success("Special visitor deleted successfully.");
      })
      .catch((err) => {
        // console.log(err);
        setIsPrintLoading(false);
        toast.error("Failed to delete Special Visitor.");
      });
  };

  const handleCopy = async (text) => {
    try {
      // First try the modern clipboard API
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
        toast.success('URL copied to clipboard!');
        return;
      }

      // Fallback for non-secure contexts and older browsers
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';  // Avoid scrolling to bottom
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        toast.success('URL copied to clipboard!');
      } catch (err) {
        console.error('Fallback copy failed:', err);
        toast.error('Failed to copy URL');
      } finally {
        document.body.removeChild(textarea);
      }
    } catch (error) {
      console.error('Failed to copy URL:', error);
      toast.error('Failed to copy URL');
    }
  };

  const columns = [
    {
      id: "srNo",
      name: "Visitor ID",
      cell: (row, index) => row._id,
    },
    {
      name: "Pass Name",
      selector: (row) => row.passName,
      sortable: true,
    },
    {
      name: "Pass Type",
      selector: (row) => row.passType,
      sortable: true,
    },
    {
      name: "Pass URL",
      selector: (row) => (
        <div className="d-flex">
          <span className={classes.passUrl}>{window.location.origin + "/" + "special-pass/" + row._id}</span>
          <span
            id="copypan"
            style={{
              cursor: "pointer",
              margin: "0",
              padding: "0",
              marginLeft: "4px",
            }}
            onClick={() => handleCopy("https://digipass.co.in/special-pass/" + row._id)}
          >
            {" "}
            <img
              src={require("../../../../assets/img/admin-images/copy.png")}
              style={{
                margin: "0",
                padding: "0",
              }}
              onMouseDown={(event) => {
                const element = event.currentTarget;
                element.style.transform = "scale(0.75)";
              }}
              onMouseUp={(event) => {
                const element = event.currentTarget;
                element.style.transform = "scale(1)";
              }}
            />
          </span>
        </div>
      ),
      sortable: true,
      width: "200px",
    },
    {
      id: "date",
      name: "Request Date & Time",
      selector: (row) => {
        const formatedDate = moment(row.createdAt).format("MMM D, hh:mm A");
        return formatedDate;
      },
      sortable: false,
      sortFunction: dateSort,
    },
    {
      name: "User/Company Name",
      selector: (row) =>
        isHidden
          ? maskText(`${row.firstName}-${row.companyName}`)
          : `${row.firstName}-${row.companyName}`,
      sortable: true,
    },
    {
      name: "Meeting Person",
      selector: (row) => row.personToVisit || "NA",
      sortable: true,
    },
    {
      name: "Location",
      selector: (row) => (isHidden ? maskText(row.location) : row.location),
      sortable: true,
    },
    {
      name: "Meeting Purpose",
      selector: (row) => row.purposeOfVisit || "NA",
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (  
        <>
          <div className={classes.icons}>
      <svg 
              xmlns="http://www.w3.org/2000/svg" 
              width="16" 
              height="16" 
              fill="currentColor" 
              viewBox="0 0 16 16"
              style={{ cursor: "pointer", marginRight: '8px' }}
              title="Print Pass"
              onClick={(e) => {
                e.stopPropagation();
                handlePrint(row,e);
              }}
            >
              <path d="M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5zm6 8H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z" />
              <path d="M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
            </svg>
            <img
              style={{ cursor: "pointer", marginRight: '8px' }}
              src={require("../../../../assets/img/admin-images/edit_thin.png")}
              alt="Edit"
              title="Edit Pass"
              onClick={() => handleEdit(row._id)}
            />
            <img
              style={{ cursor: "pointer" }}
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
              src={require("../../../../assets/img/admin-images/delete.png")}
              alt="Delete"
              title="Delete Pass"
              onClick={() =>
                setVisitorToDelete({ id: row._id, name: row.firstName })
              }
            />
          </div>
        </>
      ),
    },
  ];

  let showCsvExport = false;
  let showDownload = true;
  let showExport = false;
  let showLocation = true;
  let showSms = true;
  let showAddNew = false;
  let showFirstHr = false;
  let showSecondHr = false;
  let showActions = true;
  let showActiveVisitors = true;

  if (
    userType === "Company Manager" ||
    userType === "location" ||
    userType === "Building Manager"
  ) {
    showCsvExport = false;
    showDownload = true;
    showExport = false;
    showLocation = false;
    showSms = false;
    showAddNew = true;
    showFirstHr = false;
    showSecondHr = false;
    showActions = true;
  }
  if (userType === "Building Manager") {
    showLocation = true;
  }

  if (userType == "subadmin") {
    showDownload = false;
    showActiveVisitors = false;
  }

  if (userType == "admin") {
    showActiveVisitors = false;
  }

  const options = {
    title: "Special Visitor",
    showCsvExport: showCsvExport,
    showDownload: false,
    showExport: showExport,
    showLocation: showLocation,
    showSms: showSms,
    showAddNew: showAddNew,
    showFirstHr: showFirstHr,
    showSecondHr: showSecondHr,
    showActions: showActions,
    showActiveVisitors: showActiveVisitors,
    showVisitor: true,
    type: "SpecialVisitor",
    columns: columns,
    apiUrl: `${base_url}/visitor/list-special-visitor`,
    companyId: activeCompany._id, //for building company Id and Building Id is same
    locationId: userType === "location" ? activeLocation._id : "",
  };
 

 

  const [isPrinting, setIsPrinting] = useState(false);

  const handlePrint = (row,event) => {
    const button = event.currentTarget;
    const originalText = button.innerHTML;
    button.innerHTML = '<span>Loading...</span>';
    button.disabled = true;
    setIsPrinting(true);
    console.log(row,"row");
    try {
      // Create a hidden iframe
      const iframe = document.createElement('iframe');
      iframe.style.position = 'fixed';
      iframe.style.width = '0';
      iframe.style.height = '0';
      iframe.style.border = 'none';
      document.body.appendChild(iframe);

      // Create loading overlay
      const loadingOverlay = document.createElement('div');
      loadingOverlay.id = 'print-loading-overlay';
      loadingOverlay.style.position = 'fixed';
      loadingOverlay.style.top = '0';
      loadingOverlay.style.left = '0';
      loadingOverlay.style.width = '100%';
      loadingOverlay.style.height = '100%';
      loadingOverlay.style.backgroundColor = 'rgba(0,0,0,0.7)';
      loadingOverlay.style.display = 'flex';
      loadingOverlay.style.justifyContent = 'center';
      loadingOverlay.style.alignItems = 'center';
      loadingOverlay.style.zIndex = '9999';
      
      // Add loading spinner
      const spinner = document.createElement('div');
      spinner.style.border = '4px solid #f3f3f3';
      spinner.style.borderTop = '4px solid #3498db';
      spinner.style.borderRadius = '50%';
      spinner.style.width = '40px';
      spinner.style.height = '40px';
      spinner.style.animation = 'spin 1s linear infinite';
      
      // Add animation for spinner
      const style = document.createElement('style');
      style.id = 'print-styles';
      style.textContent = `
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }`;
      document.head.appendChild(style);
      loadingOverlay.appendChild(spinner);
      document.body.appendChild(loadingOverlay);
      style.textContent = `
        @page {
          size: auto;
          margin: 0;
        }
        body {
          margin: 0;
          padding: 0;
          display: flex;
          justify-content: center;
          align-items: center;
          min-height: 100vh;
          background: white !important;
        }
        .print-container {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100vh;
          padding: 0;
          margin: 0;
          transform: scale(1.5);
          transform-origin: top center;
        }
        .id-card {
          box-shadow: none !important;
          border: 1px solid #ddd !important;
          margin: 0 auto !important;
          width: 100%;
          max-width: 100%;
        }`;
      document.head.appendChild(style);

      // Handle iframe load
      iframe.onload = () => {
        try {
          const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
          
          // Add print styles to the iframe
          const iframeStyle = iframeDoc.createElement('style');
          iframeStyle.textContent = `
            @page {
              size: auto;
              margin: 0;
            }
            body {
              margin: 0;
              padding: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              min-height: 100vh;
              background: white !important;
            }
            .print-container {
              display: flex !important;
              justify-content: center !important;
              align-items: center !important;
              width: 100% !important;
              min-height: 100vh !important;
              padding: 20px !important;
              box-sizing: border-box !important;
            }`;
          iframeDoc.head.appendChild(iframeStyle);

          // Focus and print
          setTimeout(() => {
            if (iframe.contentWindow) {
              iframe.contentWindow.focus();
              iframe.contentWindow.print();
            }
            // Clean up after printing
            setTimeout(() => {
              if (iframe.parentNode) document.body.removeChild(iframe);
              const styles = document.getElementById('print-styles');
              const overlay = document.getElementById('print-loading-overlay');
              if (styles) document.head.removeChild(styles);
              if (overlay) document.body.removeChild(overlay);
              button.innerHTML = originalText;
              button.disabled = false;
              setIsPrinting(false);
            }, 1000);
          }, 5000);
        } catch (error) {
          console.error('Print error:', error);
          toast.error('Error printing document');
          if (iframe.parentNode) document.body.removeChild(iframe);
          const styles = document.getElementById('print-styles');
          const overlay = document.getElementById('print-loading-overlay');
          if (styles) document.head.removeChild(styles);
          if (overlay) document.body.removeChild(overlay);
          button.innerHTML = originalText;
          button.disabled = false;
          setIsPrinting(false);
        }
      };

      // Set iframe source
      iframe.src = `/print-special/${row._id}`;

      // Handle iframe error
      iframe.onerror = () => {
        toast.error('Failed to load the print document');
        if (iframe.parentNode) document.body.removeChild(iframe);
        const styles = document.getElementById('print-styles');
        const overlay = document.getElementById('print-loading-overlay');
        if (styles) document.head.removeChild(styles);
        if (overlay) document.body.removeChild(overlay);
        button.innerHTML = originalText;
        button.disabled = false;
        setIsPrinting(false);
      };
    } catch (error) {
      console.error('Error:', error);
      toast.error('An error occurred');
      // const button = event.currentTarget;
      button.disabled = false;
      const styles = document.getElementById('print-styles');
      const overlay = document.getElementById('print-loading-overlay');
      if (styles) document.head.removeChild(styles);
      if (overlay) document.body.removeChild(overlay);
      setIsPrinting(false);
    }
  }



  return (
    <>
      <Home propComponent={<Table options={options} isLoading={isPrintLoading} />} />
      <ConfirmModal
        handleDelete={handleDelete}
        id={visitorToDelete.id}
        msg={`Are you sure you want to delete special visitor ${visitorToDelete.name}?`}
      />
      

    </>
  );
};

export default SpecialVisitorWrapper;
